module.exports = __webpack_public_path__ + "static/img/advance_class.96d7280.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advance_class.png
// module id = rmj3
// module chunks = 1